import { render, staticRenderFns } from "./CommissionDetailsModal.vue?vue&type=template&id=89d44f8c"
import script from "./CommissionDetailsModal.vue?vue&type=script&lang=js"
export * from "./CommissionDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports